import { Result, Button, Row } from "antd";
import { useNavigate } from "react-router-dom";

function NotFound404() {
  const navigate = useNavigate();

  return (
    <Row justify="center">
      <Result
        status="404"
        title="404"
        subTitle="Sorry, the page you visited does not exist."
        extra={
          <Button type="primary" onClick={() => navigate("/")}>
            Back Home
          </Button>
        }
      />
    </Row>
  );
}

export function ClientError() {
  return (
    <Row justify="center">
      <Result status="error" title="Oops!" subTitle="Some error occurred" />
    </Row>
  );
}

export default NotFound404;
